import { default as cmsMapper } from "@utils/cms-mapper";
import React from "react";

interface Props {
    backgroundColor: string;
    titleColor?: string;
    textColor?: string;
    linkColor?: string;
    children?: React.ReactNode;
    sectionLinkColor?: string;
}

/**
 * TODO: This component can be removed after rebranding is complete, and just pass a background color
 * parameter to the GatsbyImageCard component.
 */
export const JWMCardStyleWrapper = (props: Props): JSX.Element => {
    const { backgroundColor, titleColor, children, textColor, linkColor, sectionLinkColor = "primary" } = props;

    const style = {
        "--card-background-color": `var(${backgroundColor})`,
    } as React.CSSProperties;

    if (titleColor) {
        style["--card-title-color"] = `var(${titleColor})`;
        style["--card-full-background-title-color"] = `var(${titleColor})`;
    }

    if (textColor) {
        style["--card-text-color"] = `var(${textColor})`;
    }

    if (linkColor && sectionLinkColor) {
        style["--text-link"] =
            linkColor === "--text-link"
                ? `var(${cmsMapper.mapSectionTextColors(sectionLinkColor)})`
                : `var(${linkColor})`;
        style["--text-link-visited"] = "var(--text-link)";
    }

    style["width"] = "100%";
    style["height"] = "100%";

    return <span style={style}>{children}</span>;
};

export default JWMCardStyleWrapper;
